import type { ModuleNav } from '@saas/ui';
export const taskNav: ModuleNav = {
  module: 'task',
  items: [
    {
      label: 'ToDo',
      to: '/tasks',
      icon: 'check_circle',
      permission: 'task.board.read',
      description: '個人とチームのボード',
    },
  ],
  admin: [
    {
      label: 'Tasuki（タスク）',
      to: '/tasks/admin',
      icon: 'assignment',
      permission: ['task.board.manage'],
      description: 'プロジェクトの一覧と所有者・容量・出所が消えた追客カード',
    },
  ],
};
